import { render, staticRenderFns } from "./Invited.vue?vue&type=template&id=0605b39e&"
import script from "./Invited.vue?vue&type=script&lang=ts&"
export * from "./Invited.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports